const states = {
  STATE_DISABLED: 'STATE_DISABLED',
  STATE_ENABLED: 'STATE_ENABLED',
} as const;

type ChatState = keyof typeof states;
export { states, type ChatState };
